import { Map } from 'immutable';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function checkTokenReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return Map({
        loading: true,
        data: null,
        error: null,
      });
    case actionTypes.SUCCESS:
      return Map({
        loading: false,
        data: action.payload,
        error: null,
      });
    case actionTypes.FAILURE:
      return Map({
        loading: false,
        data: null,
        error: action.payload,
      });
    default:
      return state;
  }
}
